import http from "@/settings/apiSettings"

class CrmSalesProductsDataService {
    save(data: any): Promise<any> {
        return http.clientComercialOdata.post("/CRM_SalesProducts", data);
    }

    update(key: string, data: any): Promise<any> {
        return http.clientComercialOdata.patch(`/CRM_SalesProducts(${key})`, data);
    }

    delete(key: string): Promise<any> {
        return http.clientComercialOdata.delete(`/CRM_SalesProducts(${key})`);
    }
}

export default new CrmSalesProductsDataService();
